export default __webpack_public_path__ + "static/media/about_hero.45e42327.png";